var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconPatientExtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6957 6H2.30435C1.58398 6 1 6.81642 1 7.82353V35.1765C1 36.1836 1.58398 37 2.30435 37H29.6957C30.416 37 31 36.1836 31 35.1765V7.82353C31 6.81642 30.416 6 29.6957 6Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5002 8.50038V15.2507C5.5002 15.8475 5.73726 16.4198 6.15924 16.8418C6.58122 17.2638 7.15354 17.5008 7.75031 17.5008C8.34708 17.5008 8.9194 17.2638 9.34138 16.8418C9.76336 16.4198 10.0004 15.8475 10.0004 15.2507V4.00015C10.0004 3.20446 9.68434 2.44136 9.1217 1.87872C8.55906 1.31609 7.79596 1 7.00027 1C6.20458 1 5.44148 1.31609 4.87885 1.87872C4.31621 2.44136 4.00012 3.20446 4.00012 4.00015V5.50023",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14H26",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22H25",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28H26",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconPatientExtract);
export default __webpack_public_path__ + "static/media/streamline-icon-patient-extract.f602bc2e.svg";
export { ForwardRef as ReactComponent };